import { AuthContextType } from './auth-types';
import { createContext } from 'react';

export const AuthContext = createContext<AuthContextType>(undefined as any);
